import { computed, ref } from 'vue'
import type { LocationMap } from '../types'
import Locations from '../data/locations.json'

const data = Locations as LocationMap

export function useResolver() {
    const code = ref('')

    const normalizedCode = computed(() => code.value.trim().toUpperCase().slice(0, 2))

    const hasLatinCharacters = computed(() => /[A-Z]/.test(normalizedCode.value))

    const location = computed(() => {
        if (normalizedCode.value.length < 2 || hasLatinCharacters.value) {
            return null
        }

        return Object.keys(data).find((key) => data[key].includes(normalizedCode.value))
    })

    const result = computed(() =>
        location.value ? `Η πινακίδα αντιστοιχεί στην περιοχή <b>${location.value}</b>` : '',
    )

    return {
        code,
        normalizedCode,
        hasLatinCharacters,
        location,
        result,
    }
}
